module.exports = __webpack_public_path__ + "static/media/garlic.a899ea2f.svg";